
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/v1/concepts/scenarios-integration",
      function () {
        return require("private-next-pages/docs/v1/concepts/scenarios-integration.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/v1/concepts/scenarios-integration"])
      });
    }
  